export default [
  {
    path: '/app/webforms',
    name: 'Webforms',
    component: () => import('@/views/Admin/Webforms/Index.vue'),
    meta: {
      pageTitle: 'Web Talepleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_WEBFORMS',
      action: 'read',
    },
  },
  {
    path: '/app/webforms/view/:id',
    name: 'WebformView',
    component: () => import('@/views/Admin/Webforms/View.vue'),
    meta: {
      pageTitle: 'Web Talepleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/webforms',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_WEBFORMS',
      action: 'read',
    },
  },
]
